import { useState } from 'react';
import { DateTime } from 'luxon';
import { Button, Calendar, Fieldset, Input, Tooltip } from '@flixbus/honeycomb-react';
import { Icon, IconCalendar, IconClose } from '@flixbus/honeycomb-icons-react';

import { toISODateEndOfDay } from '../../../../helpers/dateTime';

import { useVoucherFormContext } from '../../Context';

import { TravelPeriodRule } from '../../../../types/Rules';

const UntilDate = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const [calendarOpen, setCalendarOpen] = useState(false);

  const ruleValue = rules.filter(r => r.type === 'travel_period')[0] as
    | TravelPeriodRule
    | undefined;

  const dateObject = ruleValue?.end ? DateTime.fromISO(ruleValue.end) : null;
  const today = new Date().toISOString().split('T')[0];

  const disablePastDates = (date: Date) => {
    const min = new Date(today);
    min.setHours(0, 0, 0, 0);
    return date < min;
  };

  const calendarEndDate = new Date();
  calendarEndDate.setFullYear(calendarEndDate.getFullYear() + 5);

  // Remove the rule
  const handleClear = () => {
    handleRuleChange(
      {
        type: 'travel_period',
        ...ruleValue,
        end: '',
      },
      true,
    );
  };

  return (
    <Fieldset itemSpacing='half'>
      <Tooltip
        id='calendar-travel-until-tooltip'
        active={calendarOpen}
        disableInternalHandlers
        onToggle={() => setCalendarOpen(false)}
        position='bottom'
        alignment='start'
        size='content-fit'
        wrapAround='block'
        extraClasses='calendar-tooltip'
        content={
          <Calendar
            id='calendar-travel-until'
            appearance='compact'
            startDate={new Date(today)}
            endDate={calendarEndDate}
            selected={dateObject?.isValid ? dateObject.toJSDate() : undefined}
            showCurrentDate
            handleSelect={date => {
              handleRuleChange({
                type: 'travel_period',
                ...ruleValue,
                end: toISODateEndOfDay(DateTime.fromJSDate(date)),
              });
              setCalendarOpen(false);
            }}
            disableDayCondition={disablePastDates}
          />
        }
      >
        <Input
          name='rule-valid-until-input'
          id='rule-valid-until-input'
          label={<>Travel departure until</>}
          type='text'
          readOnly
          info={`The travel validity ends at 23:59 GMT${DateTime.local().toFormat('ZZ')}`}
          required
          value={dateObject?.isValid ? dateObject.toFormat('dd.MM.yyyy') : ''}
          placeholder='DD.MM.YYYY'
          onClick={() => setCalendarOpen(prev => !prev)}
          iconLeft={
            <Button aria-label='Open calendar' onClick={() => setCalendarOpen(prev => !prev)}>
              <Icon appearance='primary' InlineIcon={IconCalendar} />
            </Button>
          }
          iconRight={
            dateObject ? (
              <Button aria-label='Clear end date field' onClick={handleClear}>
                <Icon appearance='primary' InlineIcon={IconClose} />
              </Button>
            ) : undefined
          }
        />
      </Tooltip>
    </Fieldset>
  );
};

export default UntilDate;
